export const isBrowser =
    typeof window !== "undefined" && typeof window.document !== "undefined";

export const injectStyle = (rule: string): HTMLStyleElement => {
    const styleEl = document.createElement("style");
    document.head.appendChild(styleEl);
    const styleSheet = styleEl.sheet;
    if (styleSheet) styleSheet.insertRule(rule, styleSheet.cssRules.length);
    return styleEl;
};

export const scrollToElement = (element: HTMLElement, offset: number) => {
    window.scrollTo({
        behavior: "smooth",
        top: element.offsetTop - offset,
    });
};

export const scrollToElementByQuery = (
    elementQuery: string,
    offset: number
) => {
    scrollToElement(document.querySelector(elementQuery), offset);
};
